import {api} from "../../common/config/api";

export const SETTING_URL = {
	getLogo: `${api.withAPI}/v1/config`,
	editLogo: `${api.withAPI}/v1/config`,
}